import type { SurveyQuestionType } from "./questionTypes";

export const EDIT_SURVEY_QUESTION_TYPES: Array<{
  value: SurveyQuestionType;
  label: string;
  icon: string;
}> = [
  { value: "short_answer", label: "Short answer", icon: "📝" },
  { value: "long_answer", label: "Long answer", icon: "📄" },
  { value: "multiple_choice", label: "Multiple choice", icon: "🔘" },
  { value: "multiple_answer", label: "Checkboxes", icon: "☑️" },
  { value: "rating", label: "Rating", icon: "⭐" },
  { value: "scale", label: "Scale", icon: "📊" },
  { value: "date", label: "Date", icon: "📅" },
  { value: "time", label: "Time", icon: "🕐" },
  { value: "datetime", label: "Date & Time", icon: "📅🕐" },
  { value: "file_upload", label: "File upload", icon: "📎" },
  { value: "email", label: "Email", icon: "📧" },
  { value: "phone", label: "Phone", icon: "📞" },
  { value: "number", label: "Number", icon: "🔢" },
  { value: "yes_no", label: "Yes/No", icon: "✅❌" },
  { value: "dropdown", label: "Dropdown", icon: "📋" },
  { value: "multiple_choice_grid", label: "Multiple Choice Grid", icon: "🔲" },
  { value: "checkbox_grid", label: "Checkbox Grid", icon: "☑️🔲" },
];
